import React, { useMemo } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import SelectVirtualized from '../../../../../../../../components/Select/Virtualized';

import * as types from '../../reducer/constants';
import { getOptions, getSelectedValue } from './helper';

const FieldRefillCount = ({ form, dispatchServiceData }) => {
  const {
    refill: { refill_count },
  } = form;
  const { startCounts } = useSelector((state) => state.services);

  const selectOptions = useMemo(() => getOptions(startCounts), [startCounts]);
  const selectedValue = useMemo(() => getSelectedValue(startCounts, refill_count), [startCounts, refill_count]);

  const onChange = (selectedValue) => {
    const value = Number(selectedValue.value);
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_REFILL_COUNT, value })
  };

  return (
    <>
      <FormGroup className="form-group__refill-count">
        <ControlLabel htmlFor="refill_count">Count</ControlLabel>
        <SelectVirtualized
          components={{ IndicatorSeparator: null }}
          onChange={onChange}
          name="refill_count"
          noOptionsMessage={() => 'Not found count'}
          hideSelectedOptions={false}
          value={selectedValue}
          options={selectOptions}
          placeholder="Choose count"
        />
      </FormGroup>
    </>
  );
};

FieldRefillCount.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldRefillCount;
